import Vue from 'vue'

//  Выбираем форму слова в зависимости от количества
//  Входные значения: количество, формы слова
//  Пример:
//  1,   'ночь', 'ночи', 'ночей' -> ночь
//  3,   'ночь', 'ночи', 'ночей' -> ночи
//  100, 'ночь', 'ночи', 'ночей' -> ночей
Vue.filter('plural', function(numberp, first, second, third) {
  let form
  const number = Math.abs(numberp)
  const mod10 = number % 10
  const mod100 = number % 100

  if (mod10 === 1 && mod100 !== 11) form = 0
  else if (mod10 >= 2 && mod10 <= 4 && !(mod100 > 10 && mod100 < 20)) form = 1
  else form = 2

  switch (form) {
    case 0:
      return first
    case 1:
      return second
    case 2:
      return third
  }
})
